require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/array/from.js
 ** module id = 2480
 ** module chunks = 0
 **/